import { _ } from "../../core/polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";
import multipleDimensionsPickerWidget from "../../core/widgets/multipleDimensionsPickerWidget.js";

/**
 * Widget displaying settings (dimensions, budgets) for the rows/columns of a report.
 *
 * @param {Map} [spec.settings] - Map report item templates to their settings
 * (such as dimensions and budgets) to be used in instantiating contexts.
 * @abstract
 */
export default widget.abstractSubclass((that, my) => {
	my.initialize = function ({ settings }) {
		my.super(...arguments);
		my.report = null;
		my.settings = settings;
	};

	that.settingsUpdated = my.events.createEvent();

	that.setReport = function (report) {
		my.report = report;
	};

	that.updateSettings = function () {
		that.settingsUpdated.trigger();
	};

	that.isDisabled = function () {
		return !my.report || !my.getItems().some((item) => item.hasSettings());
	};

	that.isEnabled = function () {
		return !that.isDisabled();
	};

	that.renderContentOn = function (html) {
		my.getItems().forEach((item) => {
			if (!item.hasSettings()) {
				return;
			}
			html.h5(item.getTitle());
			html.render(my.itemSettingsRenderer(item));
		});
	};

	my.itemSettingsRenderer = function (_item) {
		my.subclassResponsibility();
	};

	my.dimensionPickerRenderer = function (item) {
		return (html) => {
			const dimensionTree = my.getDimensionTree(item);
			const dimensionPicker = multipleDimensionsPickerWidget({
				cssClass: "btn-default",
				dimensionTree,
				dimensionSpecification: item.getDimensionSpecification(),
				isNestedPopover: true,
			});

			dimensionPicker.onDimensionsSelected.register(
				(dimensionSpecification) => {
					my.registerSetting(
						item.getTemplate(),
						"dimensionSpecification",
						dimensionSpecification,
					);
				},
			);

			html.div(
				{ klass: "setting-block" },
				_("Dimensions"),
				dimensionPicker,
			);
		};
	};

	my.registerSetting = function (item, key, value) {
		if (!my.settings.get(item)) {
			my.settings.set(item, {});
		}

		my.settings.get(item)[key] = value;
	};

	my.getItems = function () {
		my.subclassResponsibility();
	};

	my.getDimensionTree = function (_item) {
		my.subclassResponsibility();
	};
});
